// 是否试驾
export const driveLists = [{
  value: '是',
  key: true
},
{
  value: '否',
  key: false
}
]
// 跟进结果
export const resultList = [{
  value: '继续跟进',
  key: 1
},
{
  value: '已成交',
  key: 2
},
{
  value: '已战败',
  key: 3
}
]

export const initPage = {
  page: 1,
  count: 10
}

export const noteTypes = [
  { key: 1, value: '到店接待' },
  { key: 2, value: '主动跟进' }
]
